import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const createAppointment = (payload) =>
  api.post("/appointments", payload).then((r) => r.data);

export const verifyAdmin = (password) =>
  api
    .post("/admin/verify", null, { headers: { "x-admin-password": password } })
    .then((r) => r.data);

export const listAppointments = (password) =>
  api
    .get("/appointments", { headers: { "x-admin-password": password } })
    .then((r) => r.data);

export const updateAppointmentStatus = (id, status, password) =>
  api
    .patch(`/appointments/${id}`, { status }, { headers: { "x-admin-password": password } })
    .then((r) => r.data);

export const deleteAppointment = (id, password) =>
  api
    .delete(`/appointments/${id}`, { headers: { "x-admin-password": password } })
    .then((r) => r.data);
